// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.head {
  background-color: #f0f5f5;
}

.form-control {
  border-radius: 1cm;
}

.modal-title {
  font-weight: 500;
  font-size: 23px;
  color: #25363F;
}

.buttons {
  float: right;
}`, "",{"version":3,"sources":["webpack://./src/pages/Objectives/popup.scss"],"names":[],"mappings":"AAAA;EAEE,yBAAA;AAAF;;AAGA;EACI,kBAAA;AAAJ;;AAEA;EACI,gBAAA;EACA,eAAA;EACA,cAAA;AACJ;;AACA;EACI,YAAA;AAEJ","sourcesContent":[".head{\n    \n  background-color: #f0f5f5;\n  \n}\n.form-control{\n    border-radius: 1cm;\n}\n.modal-title{\n    font-weight: 500;\n    font-size: 23px;\n    color: #25363F;\n}\n.buttons{\n    float: right;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
